import { Heading } from './heading.js'

export * from './heading.js'

export default Heading
